import { useEffect, useRef } from 'react';

import { useSelector } from 'editor/src/store/hooks';
import isPageCountOptionsEnabled from 'editor/src/store/hostSettings/selector/isPageCountOptionsEnabled';

import sendPostMessage from 'editor/src/util/postMessages/sendPostMessage';

// The host sells the book in page counts derived from the design, so it follows every change of the
// design's page count, whatever made it: a spread added or removed, the Product tab, undo, a new design.
function usePageCountWatcher() {
  const enabled = useSelector(isPageCountOptionsEnabled);
  const pageCount = useSelector((state) => state.design.designData?.page_count);
  const reported = useRef<number | undefined>(undefined);

  useEffect(() => {
    if (enabled && pageCount && pageCount !== reported.current) {
      reported.current = pageCount;
      sendPostMessage('design.pageCountChanged', { pageCount });
    }
  }, [enabled, pageCount]);
}

export default usePageCountWatcher;
